import React from 'react';
import LegalLayout from '../components/LegalLayout';

const PrivacyPolicy = () => {
  return (
    <LegalLayout title="Privacy Policy">
      <p>
        Intlrr respects your privacy and is committed to protecting your personal data.
      </p>

      <h3>1. Data Collection</h3>
      <p>
        We collect personal details such as name, email, phone number, and academic background solely for service delivery.
      </p>

      <h3>2. Data Usage</h3>
      <p>
        Your data is used for enrollment, communication, mentorship coordination, and service improvement.
      </p>

      <h3>3. Data Protection</h3>
      <p>
        We implement reasonable security practices to protect your data.
      </p>

      <h3>4. Third Parties</h3>
      <p>
        We do not sell or rent your personal data to third parties.
      </p>

      <h3>5. Contact</h3>
      <p>
        Privacy concerns can be addressed to <strong>support@intlrr.com</strong>.
      </p>
    </LegalLayout>
  );
};

export default PrivacyPolicy;
